// extracted by mini-css-extract-plugin
export default {"globalCard":"global_globalCard__rkKf6"};